export default function CsharpExercises() {
  return (
    <h2>Csharp Exercises</h2>
  );
}
